export class ContratoUsuarioFormModel {
    constructor(
        public email: string = '',
        public saudacao: string = '',
        public senha: string = '',
        public confirmar: string = '',
        public fone: string = '',
        public apelido: string = '',
    ) { }
}